import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid" };
const _hoisted_2 = { class: "col-12 md:col-3" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
import Skeleton from "primevue/skeleton";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(Skeleton), {
                            height: "30px",
                            "border-radius": "8px"
                        })
                    ])
                ]),
                _hoisted_3,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (index) => {
                    return _createElementVNode("div", {
                        key: index,
                        class: "grid"
                    }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (loop) => {
                            return _createElementVNode("div", {
                                key: loop,
                                class: "col-12 md:col-3"
                            }, [
                                _createVNode(_unref(Skeleton), {
                                    height: "30px",
                                    "border-radius": "8px"
                                })
                            ]);
                        }), 64))
                    ]);
                }), 64)),
                _hoisted_4,
                _hoisted_5,
                _createVNode(_unref(Skeleton), {
                    height: "130px",
                    "border-radius": "8px"
                }),
                _hoisted_6,
                _hoisted_7,
                _createVNode(_unref(Skeleton), {
                    height: "130px",
                    "border-radius": "8px"
                })
            ]));
        };
    }
});
